import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { qualifyingQuestionsApi } from '@/lib/api';

export function useQualifyingQuestions() {
  return useQuery({
    queryKey: ['qualifyingQuestions'],
    queryFn: () => qualifyingQuestionsApi.list(),
  });
}

export function useCreateQualifyingQuestion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: qualifyingQuestionsApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['qualifyingQuestions'] });
    },
  });
}

export function useUpdateQualifyingQuestion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof qualifyingQuestionsApi.update>[1] }) =>
      qualifyingQuestionsApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['qualifyingQuestions'] });
    },
  });
}

export function useDeleteQualifyingQuestion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: qualifyingQuestionsApi.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['qualifyingQuestions'] });
    },
  });
}

export function useReorderQualifyingQuestions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: qualifyingQuestionsApi.reorder,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['qualifyingQuestions'] });
    },
  });
}
